import {
  ViewExportScope,
  ViewExportType,
} from "@redotech/redo-model/views/view-exports";
import { viewSchemas } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const createViewExport = {
  name: "createViewExport" as const,
  input: z.object({
    view: viewSchemas["fulfillment-groups"],
    exportType: createEnum(ViewExportType),
    exportScope: createEnum(ViewExportScope),
    selectedDocumentIds: z.array(z.string()).optional(),
    sendToEmail: z.string().email(),
    expectedCount: z.number().optional(),
  }),
  output: z.object({ exportId: z.string(), fileUrl: z.string().optional() }),
};
